function quarticIn(t) {
  return Math.pow(t, 4.0)
}

module.exports = quarticIn


//////////////////
// WEBPACK FOOTER
// ./~/eases/quart-in.js
// module id = 153
// module chunks = 0